import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined'
import CheckIcon from '@material-ui/icons/Check'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import Typography from '@material-ui/core/Typography'
import BootstrapTable from 'react-bootstrap-table-next'
import Grid from '@material-ui/core/Grid'
import Loader from 'components/general/Loader'
import AdminAPI from 'config/api/AdminAPI'
import filterFactory, { textFilter, selectFilter, numberFilter } from 'react-bootstrap-table2-filter'
import AddCompanyModal from 'components/admin/AddCompanyModal'
import CompanyModal from 'components/admin/CompanyModal'
import componentStyles from 'assets/theme/views/admin/react-bs-table.js'

const useStyles = makeStyles(componentStyles)

// Renders a small button that copies the company ID to the clipboard.
function CopyableId({ value }) {
    const [copied, setCopied] = useState(false)
    if (!value) return <>-</>
    function copy(e) {
        e.stopPropagation()
        navigator.clipboard.writeText(value)
        setCopied(true)
        setTimeout(() => setCopied(false), 1500)
    }
    return (
        <Button
            size='small'
            variant='outlined'
            color='primary'
            onClick={copy}
            startIcon={copied ? <CheckIcon style={{ fontSize: '16px' }} /> : <FileCopyOutlinedIcon style={{ fontSize: '16px' }} />}
            style={{ textTransform: 'none', whiteSpace: 'nowrap' }}
        >
            {copied ? 'Copied!' : 'Copy Company ID'}
        </Button>
    )
}

function CompaniesTable(props) {
    const classes = { ...useStyles() }

    const companies = props.companies
    const [company, setCompany] = useState(null)
    const [showCompanyModal, setShowCompanyModal] = useState(false)
    const [showAddCompanyModal, setShowAddCompanyModal] = useState(false)
    const [loading, setLoading] = useState(false)

    const columns = [
        {
            dataField: 'companyName',
            text: 'Name',
            //sort: true,
            //filter: textFilter(),
            formatter: (cell, row) => {
                return (<Box className='hover-text primary-text' onClick={() => openCompanyModal(row)}>{row.name}</Box>)
                
            }
        },
        {
            dataField: 'billingAccount',
            text: 'Billing Account',
            sort: true,
            //filter: numberFilter(),
            formatter: (cell, row) => {
                return <>{row.billingAccount ? row.billingAccount : '-'}</>
            }
        },
        // {
        //     dataField: 'billingPeriod',
        //     text: 'Billing Period',
        //     sort: true,
        //     //filter: numberFilter(),
        //     formatter: (cell, row) => {
        //         return <>{row.billingPeriod ? row.billingPeriod : '-'}</>
        //     }
        // },
        // {
        //     dataField: 'billingMethod',
        //     text: 'Billing Method',
        //     sort: true,
        //     //filter: numberFilter(),
        //     formatter: (cell, row) => {
        //         return <>{row.billingMethod ? row.billingMethod : '-'}</>
        //     }
        // },
        // {
        //     dataField: 'dailyCaps',
        //     text: 'Daily Caps',
        //     sort: true,
        //     //filter: numberFilter(),
        //     formatter: (cell, row) => {
        //         return <>{row.dailyCapsActive ? 'On' : 'Off'}</>
        //     }
        // },
        {
            dataField: 'companyId',
            text: '',
            formatter: (cell, row) => <CopyableId value={row.companyId} />
        }
    ]

    function openCompanyModal(company) {
        setCompany(company)
        setShowCompanyModal(true)
    }

    function closeCompanyModal() {
        setShowCompanyModal(false)
        setCompany(null)
    }

    return (
        <Card>
            {!loading ? (
                <>
                    <CardHeader
                        subheader={
                            <>
                                <Box display='flex' style={{justifyContent: 'space-between'}}>
                                    <Box>
                                        <Box
                                            component={Typography}
                                            variant='h2'
                                            marginBottom='0!important'
                                        >
                                            <Box component='span'>Financial Companies</Box>
                                        </Box>
                                    </Box>
                                    <Box>
                                        <Button
                                            component={Box}
                                            onClick={() => setShowAddCompanyModal(true)}
                                            color='primary'
                                            variant='contained'
                                            size='small'
                                        >
                                            Add Company
                                        </Button>
                                    </Box>
                                </Box>
                            </>
                        }
                        classes={{ root: classes.cardHeaderRoot }}
                    ></CardHeader>

                    <div className='table-container'>
                        <BootstrapTable 
                            keyField='leadName' 
                            data={ companies } 
                            columns={ columns } 
                            filter={ filterFactory() } 
                            noDataIndication={<Box>No companies</Box>}
                        />
                    </div>

                    {showAddCompanyModal &&
                        <AddCompanyModal 
                            isOpen={showAddCompanyModal}
                            close={() => setShowAddCompanyModal(false)}
                            showSuccessAlert={(text) => props.showSuccessAlert(text)}
                            refreshCompanies={() => props.refreshCompanies()}
                        />
                    }

                    {showCompanyModal &&
                        <CompanyModal 
                            isOpen={showCompanyModal}
                            close={() => closeCompanyModal()}
                            company={company}
                            updateCompany={(company) => props.updateCompany(company)}
                            showSuccessAlert={(text) => props.showSuccessAlert(text)}
                        />
                    }
                </>
            ) : (
                <Grid container justifyContent='flex-start'>
                    <Grid item xs={12}>
                        <Box display='flex' justifyContent='center' alignItems='center' style={{height: '20vh'}}>
                            <Loader />
                        </Box>
                    </Grid>
                </Grid>
            )}
        </Card>
    );
}

export default CompaniesTable